import { config } from "@/shared/config";
import { authService } from "@/features/auth/services/authService";
import type { User } from "@/features/auth/types";
import type { IntervalsICUCredentials } from "../types";

class UserService {
  async getUser(): Promise<User> {
    const token = await authService.getAccessToken();

    const response = await fetch(
      `${config.apiBaseUrl}${config.user.getEndpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch user");
    }

    return response.json();
  }

  async setIntervalsICU(credentials: IntervalsICUCredentials): Promise<void> {
    const token = await authService.getAccessToken();

    const response = await fetch(
      `${config.apiBaseUrl}${config.user.intervalsicuEndpoint}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(credentials),
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: "Failed to save credentials" }));
      throw new Error(error.error || "Failed to save credentials");
    }
  }

  async deleteIntervalsICU(): Promise<void> {
    const token = await authService.getAccessToken();

    const response = await fetch(
      `${config.apiBaseUrl}${config.user.intervalsicuEndpoint}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: "Failed to disconnect" }));
      throw new Error(error.error || "Failed to disconnect");
    }
  }
}

export const userService = new UserService();
